import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cardOptions: 'Card options',
    isOptionNfcEnabled: {
      label: 'Contactless payment',
    },
    isOptionOnlineEnabled: {
      label: 'Online payment',
    },
    limitAtmMonth: {
      error: 'The withdrawal limit within a rolling 30-day window is {max}',
      hint: 'The maximum amount is {max}',
      label: 'Withdrawals (over 30 rolling days)',
    },
    limitPaymentWeek: {
      error: 'The payment limit within a rolling 7-day window is {max}',
      hint: 'The maximum amount is {max}',
      label: 'Payments (over 7 rolling days)',
    },
    required: 'This field is required',
    settingLimits: 'Setting limits',
  },
  fr: {
    cardOptions: 'Options de carte bancaire',
    isOptionNfcEnabled: {
      label: 'Paiement sans contact',
    },
    isOptionOnlineEnabled: {
      label: 'Paiement en ligne',
    },
    limitAtmMonth: {
      error:
        'Le plafond de retrait maximum est de {max} dans une fenêtre de 30 jours glissants.',
      hint: 'Le montant maximum est de {max}',
      label: 'Retraits (30 jours glissants)',
    },
    limitPaymentWeek: {
      error:
        'Le plafond de paiement maximum est de {max} dans une fenêtre de 7 jours glissants.',
      hint: 'Le montant maximum est de {max}',
      label: 'Paiements (7 jours glissants)',
    },
    required: 'Ce champ est requis',
    settingLimits: 'Réglages des plafonds',
  },
} as const);

export default locales;
